import { useLayoutEffect, useState } from 'react';
import ScrollListener from '@/events/ScrollListener';
export const useHeaderState = (arg) => {
    const { targetRef } = arg;
    const [headerState, changeHeaderState] = useState({
        isScrolling: false,
        isTargetScrolled: false,
    });
    useLayoutEffect(() => {
        const listenerNo = ScrollListener.setListener((scrollTop) => {
            changeHeaderState((prev) => {
                if (prev.isTargetScrolled && scrollTop === 0) {
                    // いきなり戻るようなことがあればガードしておく
                    return prev;
                }
                return {
                    isScrolling: scrollTop > 0,
                    isTargetScrolled: !!(targetRef.current && scrollTop > targetRef.current.offsetTop),
                };
            });
        });
        ScrollListener.call();
        return () => {
            ScrollListener.deleteListener(listenerNo);
        };
    }, [changeHeaderState, targetRef]);
    return headerState;
};
